import { Toaster } from 'react-hot-toast';

export function CustomToaster() {
  return (
    <Toaster
      position="top-right"
      toastOptions={{
        duration: 5000,
        style: {
          background: 'white',
          padding: 2,
          margin: 0,
          boxShadow: 'none',
          border: 'none',
        },
      }}
    />
  );
}
